import store from "../../../../app/store";
import exportimages from "../../../../assets/images/exportImages";

// const _trial_end_date = () => {
//   const state = store.getState();
//   const t = state?.stripeReducer?.acknowledgement?.trial_end || null
//   debugger;
//   return t;
// };

export const insightsAndStrategyData = {
  cardName: "Insights and Strategy",
  popupHeader: "Supercharge Your Strategy with Autopilot Enterprise!",
  popupImage: exportimages?.insights_popup_bgimg,
  popupDescription:
    "<p>Unlock the full potential of your institution's consumer data with Autopilot Enterprise! Gain access to advanced insights and personalized recommendations that help you make smarter, data-driven decisions. Autopilot Enterprise equips you with the tools to stay ahead.</p><p>Upgrade today and transform raw data into actionable results!</p>",
  showUpgradeButton: true,
};

export const cardUpgradeData = [
  {
    cardName: "sales_contacted_successfully",
    popupHeader: "Sales Contacted Successfully",
    popupImage: exportimages?.contact_sales_team_success_upgrade,
    popupDescription:
      "<p>Your message has been successfully sent to our Sales team. They will be in touch with you shortly.</p><p>Thank you for reaching out!</p>",
  },
  {
    cardName: "missed_revenue",
    popupHeader: "Recover Missed Revenue",
    popupImage: exportimages?.missed_revenue_upgrade,
    popupDescription:
      "<p>Unlock the Missed Revenue Card to discover,</p><ol class='bullet-list'><li>Revenue leaking to other institutions</li><li>Amount your consumers spend on products from other institutions</li><li>New product opportunities</li></ol>",
    showUpgradeButton: true,
  },
  {
    cardName: "consumer_behavior",
    popupHeader: "Move beyond knowing to understanding your consumer",
    popupImage: exportimages?.consumer_behavior_upgrade,
    popupDescription: `<p>Unlocking in-depth consumer behaviors insights like,</p>
      <ol class="bullet-list">
      <li>Individual financial health</li>
      <li>Personas 2.0</li>
      <li>Ghost consumers and loyalty</li>
      <li>Primary vs secondary consumers</li>
      <li>Details Demographics</li>
  </ol>`,
    showUpgradeButton: true,
  },
  {
    cardName: "uplift_loans",
    popupHeader: "Personalized loans anticipating future needs",
    popupImage: exportimages?.uplift_loans_upgrade,
    popupDescription: `<p>Find new opportunities for,</p>
      <ol class="bullet-list">
      <li>Immediate loans.</li>
      <li>Future loans based on predicted consumer needs.</li>
      <li>Filter Product Opportunities based on financial health, persona of the consumer.</li>
      <li>Mortgages, auto loans, business loans and beyond.</li>
  </ol>
      `,
    showUpgradeButton: true,
  },
  {
    cardName: "boost_deposits",
    popupHeader: "Optimize deposits, predict growth, beat competition",
    popupImage: exportimages?.boost_deposits_upgrade,
    popupDescription: `<p>Uncovers the following,</p>
      <ol class="bullet-list">
      <li>Optimal deposit opportunities and instantly shows growth potential.</li>
      <li>See deposit attrition and prevent it.</li>
      <li>Identify loan-only clients to convert into deposit clients.</li>
      <li>Filter deposit opportunities based on financial health, loyalty of the consumer.</li>
  </ol>
      `,
    showUpgradeButton: true,
  },
  {
    cardName: "beat_the_competition",
    popupHeader: "Compete with data",
    popupImage: exportimages?.beat_the_competition_upgrade,
    popupDescription: `<p>Get the edge over the other guys. Discover,</p>
      <ol class="bullet-list">
      <li>Your top competitors</li>
      <li>Your consumers other financial associations. </li>
      <li>Champion your local community with dynamic insights for both retail and small-business accounts.</li>
  </ol>
      `,
    showUpgradeButton: true,
  },
  {
    cardName: "automated_marketing",
    popupHeader: "AI-Powered Email Campaigning",
    popupImage: exportimages?.automated_marketing_upgrade,
    popupDescription: `<p>Get AI-powered insights elevate your campaign.</p>
      <ol class="bullet-list">
      <li>Automatically create lists that identify client needs early for most impact.</li>
      <li>Consciously designed pre-built templates. </li>
      <li>Prebuilt content (coming soon)</li>
      <li>Launch full campaigns with tracking </li>
  </ol>
      `,
    showUpgradeButton: true,
  },
];

export const underMaintanance = {
  cardName: "under_maintanance",
  popupHeader: "Under Maintanance!",
  popupImage: exportimages?.payment_successful_bgimg,
  popupDescription: `<p>Autopilot is temporarily unavailable while we perform scheduled maintenance. <strong>Please sign out of your account!</strong></p>`,
  showUpgradeButton: false,
  showLogoutButton: true,
  showTrialPeriod: true,
};

export const paymentSuccessfulData = {
  cardName: "payment_successful",
  popupHeader: "Upgrade Successful!",
  popupImage: exportimages?.payment_successful_bgimg,
  popupDescription: `<p>Congratulations on upgrading to the Pro version! We're excited to have you onboard. You've unlocked a world of enhanced opportunities, including exclusive features, advanced tools, and invaluable insights to elevate your experience.</p><p><strong>To enable all your new features, please sign out of your account and sign back in. Once you're back, your Pro tools will be ready for you to dive in!</strong></p>`,
  showUpgradeButton: false,
  showLogoutButton: true,
  showTrialPeriod: true,
};

export const paymentFailureData = {
  cardName: "payment_successful",
  popupHeader: "Upgrade Successful!",
  popupImage: exportimages?.payment_successful_bgimg,
  popupDescription:
    "<p>Congratulations on upgrading to the Pro version! We're excited to have you onboard. You've unlocked a world of enhanced opportunities, including exclusive features, advanced tools, and invaluable insights to elevate your experience.</p><p><strong>To enable all your new features, please sign out of your account and sign back in. Once you're back, your Pro tools will be ready for you to dive in!</strong></p>",
  showUpgradeButton: false,
  showLogoutButton: true,
};
